import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { setCouponText, clearCoupon } from '../../../actions/purchaseActions';

import { getCouponData } from '../../../apiCalls';
import { formatPrice } from '../../../utils';
import matomoTracker from '../../../utils/matomo';
import { ChevronIcon } from '../../../assets/icons/Chevron.icon';

class BoxCoupon extends Component {
  constructor(props) {
    super(props);

    this.fetchCoupon = this.fetchCoupon.bind(this);
    this.textInput = React.createRef();

    this.state = {
      coupon: '',
      collapsed: false,
    };
  }

  fetchCoupon(e) {
    e.preventDefault();
    if (this.props.couponInfo.exists) return;

    const begin_date = this.props.match.params.begin_date;
    const end_date = this.props.match.params.end_date;
    const destination = this.props.match.params.destination;
    const product_code = this.props.match.params.product_code;

    getCouponData(this.state.coupon, product_code, begin_date, end_date, destination);
    matomoTracker.trackEvent('Checkout', 'ApplyCoupon', this.state.coupon);
  }

  handleCouponChange(e) {
    this.setState({ coupon: e.target.value.toUpperCase() });
  }

  toggleCollapse() {
    this.setState((prev) => ({ collapsed: !prev.collapsed }));
  }

  onFocusCoupon() {
    if (this.props.mobile) {
      this.props.scrollToRef();
    }
  }

  selectedPaymentMethod(paymentMethods) {
    for (var pm in paymentMethods) {
      if (paymentMethods[pm].selected) {
        return paymentMethods[pm].id;
      }
    }
  }

  render() {
    const couponErrorPaymentMethod =
      this.props.couponInfo.payment_method !== undefined &&
      this.props.couponInfo.payment_method !== null &&
      this.selectedPaymentMethod(this.props.payment_methods) !== this.props.couponInfo.payment_method;
    const couponError = this.props.couponInfo.exists === false || this.props.couponInfo.notFound === true;

    if (this.props.couponInfo.exists && !couponErrorPaymentMethod) {
      return (
        <div className="box box-coupon exist">
          <div className="coupon-header" onClick={() => this.toggleCollapse()}>
            <div className="text-message">Cupom aplicado</div>
            <ChevronIcon open={this.state.collapsed} />
          </div>

          {!this.state.collapsed && (
            <React.Fragment>
              <div className="coupon-name">
                <span>{this.props.couponInfo.text}</span>
                {this.props.couponInfo.discount_type === 0 ? (
                  <strong>
                    Desconto de R${formatPrice(this.props.purchaseSummary.coupon_discount)} no seu seguro viagem
                  </strong>
                ) : (
                  <strong>{parseInt(this.props.couponInfo.discount, 0).toFixed()}% OFF no seu seguro viagem</strong>
                )}
              </div>
              <button onClick={this.props.clearCoupon}>Trocar cupom</button>
            </React.Fragment>
          )}
        </div>
      );
    }

    return (
      <div className="box box-coupon">
        <div className="coupon-header" onClick={() => this.toggleCollapse()}>
          <h4>Cupom de desconto</h4>
          <ChevronIcon open={this.state.collapsed} />
        </div>
        {!this.state.collapsed && (
          <form className="cupom-desconto">
            <input
              type="text"
              name="coupon"
              id="cupom"
              placeholder="Digite o cupom"
              value={this.state.coupon}
              onChange={(e) => this.handleCouponChange(e)}
              onFocus={() => this.onFocusCoupon()}
            />
            <button value="Submit" onClick={this.fetchCoupon}>
              Aplicar
            </button>
            {couponError && (
              <span className="custom-tooltip ">
                <b className="error">Erro: Cupom Inválido ou expirado</b>
              </span>
            )}
            {couponErrorPaymentMethod && (
              <span className="custom-tooltip ">
                <b className="error">Erro: Cupom não é válido para o tipo de pagamento selecionado</b>
              </span>
            )}
          </form>
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      couponInfo: state.purchase.coupon,
      payment_methods: state.purchase.paymentMethods,
      mobile: state.mobile.mobileActive,
      purchaseSummary: state.purchase.purchaseSummary,
    }),
    {
      setCouponText,
      clearCoupon,
    }
  )(BoxCoupon)
);



// WEBPACK FOOTER //
// ./src/components/purchase/purchase_description/BoxCoupon.jsx